<div class="viewer-shell">
  <header class="viewer-header">
    <div class="header-left">
      <a
        class="back-link"
        [routerLink]="['/projects', projectId]"
        [queryParams]="{ tab: 'forms' }"
        data-testid="viewer-back"
        aria-label="Back to forms"
        matTooltip="Back to forms"
      >
        <mat-icon class="back-icon">chevron_left</mat-icon>
      </a>
      @if (detail) {
        <div class="meta">
          <span class="form-no" data-testid="viewer-form-no">Form No. {{ detail.formNumber }}</span>
          <span class="dot">·</span>
          <span class="date">{{ detail.reportDate }}</span>
        </div>
      }
    </div>

    @if (detail) {
      <div class="header-right">
        @if (downloading) {
          <div class="download-spinner-wrapper" data-testid="pdf-download-spinner">
            <mat-spinner color="primary" diameter="24" mode="indeterminate" strokeWidth="3"></mat-spinner>
          </div>
        } @else {
          <button
            type="button"
            class="download-button"
            mat-icon-button
            data-testid="pdf-download"
            matTooltip="Download PDF"
            [disabled]="!detail.html"
            (click)="download()"
          >
            <mat-icon>download</mat-icon>
          </button>
        }
        @if (downloadError) {
          <mat-icon
            class="download-error"
            data-testid="pdf-download-error"
            matTooltip="Couldn't generate PDF. Try again."
          >error_outline</mat-icon>
        }
      </div>
    }
  </header>

  @if (loading) {
    <div class="loading" data-testid="viewer-loading">Loading…</div>
  } @else if (loadError) {
    <div class="error" data-testid="viewer-error">{{ loadError }}</div>
  } @else if (detail) {
    <div class="split" [style.--split-ratio]="splitRatio" [style.height.px]="formHeight">
      <div class="pane map-pane">
        <app-mapped-report-map-pane [geometries]="detail.geometries" [site]="detail.site" />
      </div>
      <div class="splitter" data-testid="viewer-splitter" (mousedown)="onSplitterDown($event)"></div>
      <div class="pane pdf-pane">
        <app-mapped-report-pdf-pane [html]="detail.html" (formHeight)="onFormHeight($event)" />
      </div>
    </div>
  }
</div>
